import type { SxProps, Theme } from '@mui/material/styles';

import { HcoCard } from '@/components/Hco/HcoCard/HcoCard';
import { HcpCard, CardView } from '@/components/Hcp/HcpCard/HcpCard';
import { Hcphco } from '@/core/graphql/generated/types';
import { isOfTypeHco } from '@/utils/hco/isOfTypeHco';
import { isOfTypeHcp } from '@/utils/hcp/isOfTypeHcp';

type Props = {
	profile: Hcphco;
	view?: CardView;
	withIcon?: boolean;
	withFullAddress?: boolean;
	wrapChips?: boolean;
	customSx?: {
		root?: SxProps<Theme>;
		content?: SxProps<Theme>;
		name?: SxProps<Theme>;
	};
};

export const ProfileCard = ({
	profile,
	view,
	withIcon = true,
	withFullAddress,
	wrapChips,
	customSx
}: Props) => {
	const sx = {
		name: [
			{ fontWeight: 'unset' },
			view === 'compact' && {
				maxWidth: '100%',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				whiteSpace: 'nowrap'
			},
			customSx?.name ?? false
		] as SxProps<Theme>,
		content: [
			{ gap: 0 },
			view === 'basic' && {
				textAlign: 'center'
			},
			view === 'compact' && {
				maxWidth: 'calc(100% - 40px - (2 * var(--mui-spacing)))'
			},
			customSx?.content ?? false
		] as SxProps<Theme>,
		root: [
			{
				'&:hover': {
					backgroundColor: 'unset'
				}
			},
			view === 'basic' && {
				flexDirection: 'column',
				padding: 1,
				borderRadius: 1
			},
			customSx?.root ?? false
		] as SxProps<Theme>
	};

	if (isOfTypeHcp(profile)) {
		return (
			<HcpCard
				hcp={profile}
				withIcon={withIcon}
				withFullAddress={withFullAddress}
				view={view}
				wrapChips={wrapChips}
				disableLink
				affiliationType='link'
				customSx={sx}
			/>
		);
	}

	if (isOfTypeHco(profile)) {
		return (
			<HcoCard
				hco={profile}
				withIcon={withIcon}
				withFullAddress={withFullAddress}
				view={view}
				wrapChips={wrapChips}
				disableLink
				customSx={sx}
			/>
		);
	}

	return null;
};
